var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGadzhety = function SvgGadzhety(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#F2F0FC",
    rx: 20
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6432C8",
    d: "m22.844 18.925-2.388.979-1.346-2.713-1.193.49 1.883 3.798 3.582-1.468-.538-1.086Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#6432C8",
    fillRule: "evenodd",
    d: "M24.326 14.498a3.812 3.812 0 0 0-.265-.22 3.586 3.586 0 0 1-.934-1.1 2.975 2.975 0 0 0-2.591-1.511h-.596c-1.11 0-2.08.609-2.59 1.511-.24.42-.55.81-.934 1.1-.092.07-.18.143-.265.22-.737.67-1.151 1.579-1.151 2.526v5.952c0 .948.414 1.856 1.15 2.526.086.077.174.15.266.22.385.291.695.68.933 1.1a2.975 2.975 0 0 0 2.591 1.511h.596c1.11 0 2.08-.609 2.591-1.511.238-.42.548-.809.934-1.1.091-.07.18-.143.265-.22.736-.67 1.15-1.578 1.15-2.526v-5.952c0-.947-.414-1.856-1.15-2.526Zm-2.768 10.86a2.764 2.764 0 0 0 1.795-.657c.486-.42.777-.996.81-1.606l.004-.119v-5.952a2.27 2.27 0 0 0-.722-1.641 2.74 2.74 0 0 0-1.766-.737l-.131-.003h-2.62c-.671 0-1.318.235-1.805.656a2.294 2.294 0 0 0-.81 1.606l-.003.119v5.952c0 .611.258 1.199.72 1.641a2.74 2.74 0 0 0 1.768.737l.13.003h2.63Z",
    clipRule: "evenodd"
  })));
};
export default SvgGadzhety;